var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{staticClass:"pl-lg-12",attrs:{"height":"30","color":"red","app":""}},[_c('div',{staticClass:"mx-auto white--text"},[_vm._v(" "+_vm._s(_vm.$t('layout.components.impersonateBar.authorizedAs'))+" "+_vm._s(_vm.impersonateUser)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }